import { logger } from '@parrot-software/observability';

import type { ISubscriptionBlockApiPort } from '@subscriptions/application/ports';
import type { UpdateBlockStoresDto } from '@subscriptions/application/dtos';
import { extractErrorAttributes } from '@subscriptions/application/utils';

const subLog = logger.forDomain('SUB', { subdomain: 'lifecycle' });

/**
 * Use case for updating the name and stores of a subscription block.
 *
 * @param port - Subscription block API port
 * @returns Use case executor
 */
export const updateBlockStoresUseCase = (port: ISubscriptionBlockApiPort) => {
  const execute = async (blockUuid: string, dto: UpdateBlockStoresDto): Promise<{ uuid: string }> => {
    try {
      const result = await port.updateStores(blockUuid, dto);
      subLog.info('updateBlockStores', {
        'block.uuid': blockUuid,
        'block.storeCount': dto.storeUuids.length,
      });
      return result;
    } catch (error) {
      subLog.error('updateBlockStores', {
        ...extractErrorAttributes(error),
        'block.uuid': blockUuid,
      });
      throw error;
    }
  };

  return { execute };
};
